import UIHoverCardController from "./shared/hover-card_controller";

export default class UITooltipController extends UIHoverCardController {}
